import { Service } from "mvc-kit";
var ActivityFeedService = class extends Service {
	rpcService;
	constructor(rpcService) {
		super();
		this.rpcService = rpcService;
	}
	/**
	* `signal` is accepted so the ViewModel can pass its `disposeSignal`; the RPC
	* client's `call` currently accepts only `{timeout}`, so it is reserved for
	* when signal support lands.
	*/
	async getActivityFeed(args, _signal) {
		const { data } = await this.rpcService.ActivityFeed.GetOpsActivityFeed.v1.call(args, { timeout: 6e4 });
		return {
			activity: data.activity,
			hasMore: data.activity.length >= 20
		};
	}
};
//#endregion
export { ActivityFeedService };

//# sourceMappingURL=ActivityFeedService.js.map